export interface Attachment {
  name: string
  contentBytes: string
  contentType: string
  contentId?: string
}

export interface QualityRedFlag {
  redFlagId: string
  targetUserId: string
  targetUsername: string
  targetEmail: string
  level: number
  processCode?: string
  processName?: string
  recordCode?: string
  activity?: string
  concreteFacts?: string
  description?: string
  sanctionType?: string
  incidentDate?: string
  evidenceUrls?: string[]
  issuedAt: string
  issuedBy: string
  isActive?: boolean
}

export interface CreateQualityRedFlagDto {
  targetUserId: string
  targetUsername: string
  targetEmail: string
  level: number
  processCode?: string
  processName?: string
  recordCode?: string
  activity?: string
  concreteFacts?: string
  description?: string
  sanctionType?: string
  incidentDate?: string
  evidenceUrls?: string[]
  attachments?: Attachment[]
}

export interface BiocellsmedUser {
  id: string
  name: string
  email: string
  firstName?: string
  lastName?: string
  redFlagsSummary?: {
    total: number
    level1: number
    level2: number
    level3: number
  }
}

export enum QualityRewardType {
  BADGE = "BADGE",
  TIME_BONUS = "TIME_BONUS",
  VACATION_PRIORITY = "VACATION_PRIORITY"
}

export interface CreateQualityRewardDto {
  targetUserId: string
  targetUsername: string
  targetEmail: string
  type: QualityRewardType
  comment?: string
  attachments?: Attachment[]
  evidenceUrls?: string[]
}

export interface QualityReward {
  rewardId: string
  targetUserId: string
  targetUsername: string
  targetEmail: string
  type: QualityRewardType
  comment?: string
  evidenceUrls?: string[]
  issuedAt: string
  issuedBy: string
}

export interface QualityUserHistoryResponse {
  success: boolean
  data: QualityRedFlag[]
  total: number
  user: BiocellsmedUser | null
}

export interface QualityUserRewardsHistoryResponse {
  success: boolean
  data: QualityReward[]
  total: number
  user: BiocellsmedUser | null
}
